import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListOl, faListUl } from "@fortawesome/free-solid-svg-icons";

import StyleButton from "./style-button";

const BLOCK_TYPES = [
    { label: "Unordered List", icon: <FontAwesomeIcon icon={faListUl} />, style: "unordered-list-item" },
    { label: "Ordered List", icon: <FontAwesomeIcon icon={faListOl} />, style: "ordered-list-item" },
];

const BlockStyleControls = (props) => {
    const { editorState } = props;
    const selection = editorState.getSelection();
    const blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();

    return (
        <div className="rich-text-control-group">
            {BLOCK_TYPES.map((type) => (
                <StyleButton
                    key={type.label}
                    active={type.style === blockType}
                    label={type.label}
                    icon={type.icon}
                    onToggle={props.onToggle}
                    style={type.style}
                />
            ))}
        </div>
    );
};

export default BlockStyleControls;
